import React, { useContext } from 'react';
import classNames from 'classnames';

import SessionGatedLink from 'src/components/SessionGatedLink';
import { LanguageContext } from 'src/contexts';
import translations from 'src/lang';
import { getProductLink } from 'src/utils';
import { sendEvent } from 'src/actions/EventsActions';

import { HomeProduct } from '../../api/request';
import { ProductTile } from './ProductTitle';

type ProductPanelProps = {
  products: HomeProduct[];
};

export const ProductPanel = ({ products }: ProductPanelProps) => {
  const lang = (useContext(LanguageContext) ??
    'en-US') as keyof typeof translations;
  const { PAGE_HOME } = translations[lang];

  return (
    <div className="grid grid-cols-4 gap-4">
      {products.map((item) => {
        const isDisabled = item.enabled === false;

        return (
          <div
            key={item.id}
            className={classNames(
              'relative flex h-full w-full flex-col overflow-hidden rounded bg-white shadow-panel',
              {
                'filter grayscale opacity-60 cursor-default': isDisabled,
              }
            )}
            aria-disabled={isDisabled || undefined}
          >
            {isDisabled ? (
              <ProductTile item={item} />
            ) : (
              <SessionGatedLink
                className="block h-full"
                href={`//${getProductLink(item.slug)}`}
                restoringLabel={PAGE_HOME.RESTORING_SESSION}
                onNavigate={() => sendEvent(`Opening ${item.name}`)}
              >
                <ProductTile item={item} />
              </SessionGatedLink>
            )}
          </div>
        );
      })}
    </div>
  );
};
